import { gql } from '@apollo/client'

import { iconViewFragment } from 'js/lib/fragments/icon'

const GET_SEARCH_CONTAINER = gql`
    query SearchContainer($containerGuid: String) {
        viewer {
            guid
            loggedIn
            user {
                guid
                email
            }
        }
        entity(guid: $containerGuid) {
            guid
            ... on Group {
                name
                ${iconViewFragment}
                url
            }
        }
        site {
            guid
            customTagsAllowed
            searchRelatedSitesEnabled
            defaultSearchOrderBy
            defaultSearchDirection
            tagCategories {
                name
                values
            }
            searchRelatedSites {
                name
                url
            }
            recommendedType
            searchDisplayedFilters
            searchTagFilters {
                name
                tagFilterEnabled
                tagFilterType
            }
        }
        siteStats {
            archiveSize
        }
    }
`

export default GET_SEARCH_CONTAINER
